"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Observable_1 = require("rxjs/Observable");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var operators_1 = require("rxjs/operators");
var http_1 = require("@angular/common/http");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var root_entity_config_model_1 = require("../../../../controls/summary-pages/common/model/root-entity-config.model");
var overview_config_model_1 = require("../../../../controls/summary-pages/common/model/overview-config.model");
var base_portfolio_config_model_1 = require("../../../../controls/summary-pages/common/model/base-portfolio-config.model");
var overview_config_item_model_1 = require("../../../../controls/summary-pages/common/model/overview-config-item.model");
var overview_field_type_1 = require("../../../../controls/summary-pages/common/model/overview-field-type");
var overview_content_field_model_1 = require("../../../../controls/summary-pages/common/model/overview-content-field.model");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_authorization_client_js_1 = require("@synisys/idm-authorization-client-js");
var static_method_1 = require("../../../utils/static-method");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_dynamic_layout_interpreter_1 = require("@synisys/idm-dynamic-layout-interpreter");
var idm_form_management_ui_1 = require("@synisys/idm-form-management-ui");
var HttpRootCategorySummaryPageConfigService = /** @class */ (function () {
    function HttpRootCategorySummaryPageConfigService(http, kbService, authorizationService, sessionDataProvider, formManagementService, applicationPropertiesService) {
        this.http = http;
        this.kbService = kbService;
        this.authorizationService = authorizationService;
        this.sessionDataProvider = sessionDataProvider;
        this.formManagementService = formManagementService;
        this.applicationPropertiesService = applicationPropertiesService;
        this.serviceUrlKey = 'cms-service-url';
        this.serviceResource = '/entity-configs';
        this._cache$ = new Map();
        this.serviceUrl$ = Observable_1.Observable.from(this.applicationPropertiesService.getProperty(this.serviceUrlKey)).pipe(operators_1.shareReplay(1));
    }
    HttpRootCategorySummaryPageConfigService.prototype.save = function (rootEntityConfigModel) {
        var _this = this;
        idm_common_util_frontend_1.PreconditionCheck.notNull(rootEntityConfigModel);
        idm_common_util_frontend_1.PreconditionCheck.notNull(rootEntityConfigModel.category);
        this._cache$.delete(rootEntityConfigModel.category);
        return this.serviceUrl$.pipe(operators_1.switchMap(function (serviceUrl) {
            var url = "" + serviceUrl + _this.serviceResource;
            return _this.http.put(url + '/' + rootEntityConfigModel.category, _this.constructJsonFromConfigs(rootEntityConfigModel), {
                responseType: 'text',
                headers: new http_1.HttpHeaders({ 'Content-Type': 'application/json' })
            });
        }));
    };
    HttpRootCategorySummaryPageConfigService.prototype.getConfigByRootCategory = function (rootCategoryId, rootEntityId) {
        if (rootEntityId) {
            return this.getPermittedConfigByRootCategory(rootCategoryId, rootEntityId);
        }
        return this.getConfigByRootCategoryFromCache(rootCategoryId);
    };
    HttpRootCategorySummaryPageConfigService.prototype.getPortfolioConfigByCategory = function (categoryId, rootCategoryId) {
        var _this = this;
        return this.getConfigByRootCategoryFromCache(rootCategoryId).pipe(operators_1.switchMap(function (config) {
            if (categoryId !== rootCategoryId) {
                var overviewConfig = config.overviewConfigModel.overviewItemsConfig.find(function (itemConfig) { return itemConfig.itemCategoryName === categoryId; });
                if (overviewConfig && overviewConfig.portfolioConfig) {
                    return _this.getDefaultPortfolioConfigIfNotExists(categoryId, overviewConfig.portfolioConfig);
                }
                return _this.getDefaultPortfolioConfigIfNotExists(categoryId, new base_portfolio_config_model_1.BasePortfolioConfigModel());
            }
            return _this.getDefaultPortfolioConfigIfNotExists(rootCategoryId, config.basePortfolioConfigModel);
        }));
    };
    HttpRootCategorySummaryPageConfigService.prototype.getCardConfigByCategory = function (categoryId, rootCategoryId) {
        return this.getConfigByRootCategoryFromCache(rootCategoryId)
            .pipe(operators_1.map(function (overviewConfig) {
            return overviewConfig.overviewConfigModel.overviewItemsConfig.find(function (itemConfig) {
                return itemConfig.itemCategoryName === categoryId;
            });
        }));
    };
    HttpRootCategorySummaryPageConfigService.prototype.getCardConfigByCustomUrl = function (customUrl, rootCategoryId) {
        return this.getConfigByRootCategoryFromCache(rootCategoryId)
            .pipe(operators_1.map(function (overviewConfig) {
            return overviewConfig.overviewConfigModel.overviewItemsConfig.find(function (itemConfig) {
                return itemConfig.customUrl === customUrl;
            });
        }));
    };
    // ---------------------- Helpers ----------------------------------
    HttpRootCategorySummaryPageConfigService.prototype.getConfigByRootCategoryFromCache = function (rootCategoryId) {
        if (!this._cache$.get(rootCategoryId)) {
            this._cache$.set(rootCategoryId, this.constructCategoryConfigurationRequest(rootCategoryId).pipe(operators_1.shareReplay(1)));
        }
        return this._cache$.get(rootCategoryId);
    };
    HttpRootCategorySummaryPageConfigService.prototype.getPermittedConfigByRootCategory = function (rootCategoryId, rootEntityId) {
        var _this = this;
        return this.getConfigByRootCategoryFromCache(rootCategoryId).pipe(operators_1.switchMap(function (rootEntityConfigModel) { return _this.filterPermittedCards(rootCategoryId, rootEntityId, rootEntityConfigModel); }));
    };
    HttpRootCategorySummaryPageConfigService.prototype.constructJsonFromConfigs = function (rootEntityConfigModel) {
        var json = {};
        json['category'] = rootEntityConfigModel.category;
        json['formName'] = rootEntityConfigModel.formId;
        json['portfolioConfig'] = {};
        json['portfolioConfig']['quickFilterField'] = rootEntityConfigModel.basePortfolioConfigModel.quickFilterField;
        json['portfolioConfig']['defaultSortingField'] = rootEntityConfigModel.basePortfolioConfigModel.defaultSortingField;
        json['portfolioConfig']['sortingDirection'] = rootEntityConfigModel.basePortfolioConfigModel.sortingDirection;
        json['portfolioConfig']['filterFields'] = rootEntityConfigModel.basePortfolioConfigModel.filterFields;
        json['portfolioConfig']['fields'] = rootEntityConfigModel.basePortfolioConfigModel.fields.map(function (field) { return JSON.stringify(field); });
        json['overviewConfig'] = {};
        json['overviewConfig']['data'] = JSON.stringify(rootEntityConfigModel.overviewConfigModel.overviewItemsConfig);
        json['overviewConfig']['hasHeader'] = true;
        json['overviewConfig']['hasSubwayMap'] = true;
        return json;
    };
    HttpRootCategorySummaryPageConfigService.prototype.constructCategoryConfigurationRequest = function (rootCategoryId) {
        var _this = this;
        return this.serviceUrl$.pipe(operators_1.switchMap(function (serviceUrl) {
            var url = "" + serviceUrl + _this.serviceResource + "/" + rootCategoryId;
            return _this.http.get(url).pipe(operators_1.map(function (response) { return _this.deserializeConfig(response); }), operators_1.catchError(function (error) {
                // if no configurations found return default one
                if (error.status === 404) {
                    var loadViewForm$ = _this.loadCategoryDefaultViewForm(rootCategoryId);
                    var loadPortfolioConfigs$ = _this.getDefaultPortfolioConfigIfNotExists(rootCategoryId);
                    return Observable_1.Observable.zip(loadViewForm$, loadPortfolioConfigs$).pipe(operators_1.map(function (_a) {
                        var viewFormId = _a[0], basePortfolioConfigs = _a[1];
                        return new root_entity_config_model_1.RootEntityConfigModel(rootCategoryId, viewFormId, new overview_config_model_1.OverviewConfigModel(), basePortfolioConfigs);
                    }));
                }
                return Observable_1.Observable.throw(error);
            }));
        }));
    };
    HttpRootCategorySummaryPageConfigService.prototype.loadCategoryDefaultViewForm = function (categoryId) {
        return this.formManagementService.loadFormsByCategoryAndType(categoryId, idm_dynamic_layout_interpreter_1.FormType.VIEW).pipe(operators_1.map(function (forms) { return forms && forms.length ? forms[0].id.toString() : null; }));
    };
    HttpRootCategorySummaryPageConfigService.prototype.getDefaultPortfolioConfigIfNotExists = function (category, config) {
        if (config === void 0) { config = new base_portfolio_config_model_1.BasePortfolioConfigModel(); }
        if (config) {
            if (config.fields && config.fields.length && config.filterFields && config.filterFields.length) {
                return Observable_1.Observable.of(config);
            }
            return this.kbService.getNameMetaFieldIds(category).map(function (metaFieldIds) {
                var names = metaFieldIds.map(function (metaFieldId) { return metaFieldId.getSystemName(); });
                if (!config.fields || !config.fields.length) {
                    config.fields = names.map(function (field) {
                        return new overview_content_field_model_1.OverviewContentPortfolioFieldModel(overview_field_type_1.OverviewPortfolioFieldType.FIELD, field);
                    });
                }
                if (!config.filterFields || !config.filterFields.length) {
                    config.filterFields = names;
                }
                return config;
            });
        }
        return null;
    };
    HttpRootCategorySummaryPageConfigService.prototype.deserializeConfig = function (response) {
        var _this = this;
        if (response) {
            var overviewConfig = new overview_config_model_1.OverviewConfigModel();
            var basePortfolioConfig = new base_portfolio_config_model_1.BasePortfolioConfigModel();
            var rootEntityConfig = new root_entity_config_model_1.RootEntityConfigModel(response['category'], response['formName'], overviewConfig, basePortfolioConfig);
            if (response['overviewConfig']['data']) {
                rootEntityConfig.overviewConfigModel.overviewItemsConfig = JSON.parse(response['overviewConfig']['data']);
                rootEntityConfig.overviewConfigModel.overviewItemsConfig = overviewConfig.overviewItemsConfig.map(function (item) {
                    return overview_config_item_model_1.OverviewConfigItemModel.cloneFromItem(item);
                });
                rootEntityConfig.overviewConfigModel.overviewItemsConfig.forEach(function (overviewItem) {
                    if (overviewItem.portfolioConfig) {
                        overviewItem.portfolioConfig.fields = _this.setFieldsOnIncorrectValue(overviewItem.portfolioConfig.fields);
                    }
                    if (overviewItem.contentFieldsWithLevels) {
                        overviewItem.contentFieldsWithLevels.forEach(function (contentField) {
                            return contentField.data = _this.setFieldsOnIncorrectValue(contentField.data);
                        });
                    }
                });
            }
            else {
                rootEntityConfig.overviewConfigModel.overviewItemsConfig = [];
            }
            rootEntityConfig.basePortfolioConfigModel.quickFilterField = response['portfolioConfig']['quickFilterField'];
            rootEntityConfig.basePortfolioConfigModel.defaultSortingField = response['portfolioConfig']['defaultSortingField'];
            rootEntityConfig.basePortfolioConfigModel.sortingDirection = response['portfolioConfig']['sortingDirection'];
            rootEntityConfig.basePortfolioConfigModel.filterFields = response['portfolioConfig']['filterFields'];
            response['portfolioConfig']['fields'] = this.setFieldsOnIncorrectValue(response['portfolioConfig']['fields']);
            rootEntityConfig.basePortfolioConfigModel.fields = response['portfolioConfig']['fields'];
            return rootEntityConfig;
        }
        return null;
    };
    HttpRootCategorySummaryPageConfigService.prototype.setFieldsOnIncorrectValue = function (fields) {
        var result = fields;
        if (fields && fields.length && typeof fields[0] === 'string') {
            try {
                result = fields.map(function (field) { return JSON.parse(field); });
            }
            catch (e) {
                result = fields.map(function (field) {
                    return {
                        fieldName: field,
                        overviewPortfolioFieldType: overview_field_type_1.OverviewPortfolioFieldType.FIELD
                    };
                });
            }
        }
        return result;
    };
    HttpRootCategorySummaryPageConfigService.prototype.filterPermittedCards = function (rootCategoryId, rootEntityId, rootEntityConfigModel) {
        var _this = this;
        var categories = rootEntityConfigModel.overviewConfigModel.overviewItemsConfig
            .map(function (cardConfig) { return cardConfig.itemCategoryName; })
            .filter(function (a) { return !!a; });
        return this.sessionDataProvider.getCurrentUserData().pipe(operators_1.switchMap(function (currentUserData) {
            var categoryPermissionRequestDataDto = {
                userId: currentUserData.userId,
                categorySystemNames: Array.from(new Set(categories)),
                workflowStateId: null,
                permissionType: idm_authorization_client_js_1.PermissionType.VIEW,
                conditionalPermissionValues: null
            };
            var permittedCategories$ = _this.authorizationService.getCategoryPermissionsValues(categoryPermissionRequestDataDto)
                .pipe(operators_1.map(function (viewPermissions) {
                return categories.filter(function (category) { return static_method_1.hasPermission(viewPermissions.get(category)); });
            }));
            return permittedCategories$.pipe(operators_1.map(function (permittedCategories) {
                rootEntityConfigModel.overviewConfigModel.overviewItemsConfig =
                    rootEntityConfigModel.overviewConfigModel.overviewItemsConfig.filter(function (cardConfig) {
                        return !cardConfig.itemCategoryName || permittedCategories.indexOf(cardConfig.itemCategoryName) !== -1;
                    });
                return rootEntityConfigModel;
            }));
        }));
    };
    HttpRootCategorySummaryPageConfigService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [http_1.HttpClient,
            idm_kb_service_client_js_1.KbService,
            idm_authorization_client_js_1.AuthorizationService,
            idm_session_data_provider_api_js_1.SessionDataProvider,
            idm_form_management_ui_1.FormManagementService,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpRootCategorySummaryPageConfigService);
    return HttpRootCategorySummaryPageConfigService;
}());
exports.HttpRootCategorySummaryPageConfigService = HttpRootCategorySummaryPageConfigService;
//# sourceMappingURL=http-root-category-summary-page-config.service.js.map